export default __webpack_public_path__ + "static/media/2.212f97ea.png";